import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { StackLayout } from '@progress/kendo-react-layout';
import { useViewsContext, useGlobalizationContext, useTranslation, useGetView } from '@cs-cms/state-management';
import { DEFAULT_FACETS_COUNT } from '@cs-cms/types';

export const NoPrivateViewContent: React.FC = () => {
  const { setEditingViewState, selectedView } = useViewsContext();
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  const { data: currentlySelectedView } = useGetView(selectedView, selectedLocale);

  const createPrivateViewBasedOnDefault = () => {
    if (setEditingViewState && currentlySelectedView) {
      const fields = currentlySelectedView.fields.map(field => ({
        id: field.id,
        name: field.displayName || field.name,
        width: field.width,
        isDocumentLink: field.isDocumentLink,
        facetable: field.facetable,
        facetsCount: field.facetable ? DEFAULT_FACETS_COUNT : undefined
      }));
      setEditingViewState({ fields, activeField: undefined, globalFilters: currentlySelectedView.globalFilters });
    }
  };

  return (
    <div>
      <StackLayout
        orientation={'horizontal'}
        align={{ horizontal: 'center', vertical: 'middle' }}
        gap={25}
        style={{ margin: 25 }}
      >
        <h3 className="noViewText">{translate('custom.settings.views.private.noView')}</h3>
        {currentlySelectedView && (
          <Button
            themeColor="primary"
            title={translate('custom.settings.views.private.addNew')}
            style={{ maxWidth: 150 }}
            onClick={createPrivateViewBasedOnDefault}
          >
            {translate('custom.settings.views.private.addNew')}
          </Button>
        )}
      </StackLayout>
    </div>
  );
};
